import ApiService from './';
import { ImportReviewParams } from '../params/redux/review';

/**
 * @heading1: Reminder API service.
 *
 * Provides a collection of methods to interact with the Reminder API.
 * Includes operations for managing reminder related functionalities.
 */

const ReviewApi = {
    /**
 * @heading3: Get Deal Reminders
 * @paragraph: Sends a POST request to retrieve reminders for a specific deal.
 * @param: {string} token - The user's authentication token.
 * @param: {number} id - The ID of the deal to fetch reminders for.
 */
    searchBusinessReviews: (token: string, search_query: string) => {
        return ApiService.apiHit({
            url: 'get-business',
            method: 'post',
            token,
            data: { search_query },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    importReviews: (token: string, data: { data: ImportReviewParams[], client_id: number}) => {
        return ApiService.apiHit({
            url: 'post-task',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchReviews: (token: string, client_id: number) => {
        return ApiService.apiHit({
            url: 'get-all-business',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchRequests: (token: string, client_id: number) => {
        return ApiService.apiHit({
            url: 'get-all-pending-business',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default ReviewApi;
